import { useAppRouter } from '@/common/route/useAppRouter';
import { StringUtils } from '@/common/utils/stringUtils';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_RFM } from '@/modules/rfm/router';
import { rfmService } from '@/services/rfm';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useRfmGroup() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: StringUtils.toNumber(route.params.id),
        name: ''
    });

    const validations = {
        name: { required }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        canExecute: () => model.id != null,
        request: () => rfmService.group.get(model.id),
        onSuccess: ({ data }) => Object.assign(model, data),
        onError: () => router.push({ name: ROUTE_NAME_RFM.GROUP.INDEX })
    });

    const actions = {
        create: crudAction.confirmAndExecute({
            validator: v$,
            request: () => rfmService.group.create(model.name),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.GROUP.INDEX })
        }),
        update: crudAction.confirmAndExecute({
            validator: v$,
            request: () => rfmService.group.update(model.id, model.name),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.GROUP.INDEX })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => rfmService.group.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_RFM.GROUP.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
